import devConfig from './growthbook.dev.json';
import prodConfig from './growthbook.prod.json';
export default process.env.APP_ENV === 'prod' ? prodConfig : devConfig;
